"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Link_1 = __importDefault(require("../Link"));
var _1 = require(".");
var Box_1 = __importDefault(require("../Box"));
var LinkContainer = (0, styled_1.default)(Box_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'relative',
        height: _1.MENU_HEIGHT,
        display: 'flex',
        alignItems: 'center',
        fontSize: theme.fontSizes[2],
        fontWeight: 'normal',
        letterSpacing: 'normal',
        lineHeight: 'normal',
        '&:hover .sub-links': {
            display: 'flex'
        },
    });
});
var StyledLink = (0, styled_1.default)(Link_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        letterSpacing: '0.8px',
        marginLeft: theme.space[_1.NAV_ITEM_MARGIN_SCALE],
    });
});
var StyledSubLink = (0, styled_1.default)(Link_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.colors.black,
        margin: theme.space[3],
    });
});
var SubLinkContainer = (0, styled_1.default)(Box_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'none',
        position: 'absolute',
        top: _1.MENU_HEIGHT,
        flexDirection: 'column',
        alignItems: 'center',
        background: theme.colors.white,
        width: '160px'
    });
});
var MenuGroup = function (props) {
    var menuSet = props.menuSet, isLoggedIn = props.isLoggedIn;
    return (react_1.default.createElement(react_1.default.Fragment, null, menuSet === null || menuSet === void 0 ? void 0 : menuSet.map(function (item) {
        var _a;
        return (react_1.default.createElement(LinkContainer, { key: item.url },
            react_1.default.createElement(StyledLink, { href: item.url, "data-event-location": "header_menu", "data-event-label": item.label }, (isLoggedIn && item.loggedInLabel) ? item.loggedInLabel : item.label),
            react_1.default.createElement(SubLinkContainer, { className: "sub-links" }, (_a = item.subnav) === null || _a === void 0 ? void 0 : _a.map(function (sub) { return (react_1.default.createElement(StyledSubLink, { key: sub.url, href: sub.url, "data-event-location": "header_menu", "data-event-label": item.label }, (isLoggedIn && sub.loggedInLabel) ? sub.loggedInLabel : sub.label)); }))));
    })));
};
exports.default = MenuGroup;
